import { render, staticRenderFns } from "./catalogue.vue?vue&type=template&id=64447c2d&scoped=true"
import script from "./catalogue.vue?vue&type=script&lang=js"
export * from "./catalogue.vue?vue&type=script&lang=js"
import style0 from "./catalogue.vue?vue&type=style&index=0&id=64447c2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64447c2d",
  null
  
)

export default component.exports